"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constellation_1 = require("@zillow/constellation");
const react_1 = __importStar(require("react"));
const CardsContext_1 = __importDefault(require("../../context/CardsContext"));
const defaultLabels_1 = require("../../utils/data/defaultLabels");
const tab_click_1 = require("../../utils/clickstream/tab-click");
const PersonalizedRateCard = () => {
    const clickstream_displayed_txt = 'blue_card_button';
    const { blueCardButtonText, blueCardLink, blueCardText, blueCardImage } = (0, react_1.useContext)(CardsContext_1.default);
    const btnLabel = blueCardButtonText || defaultLabels_1.blueCardPlaceholders.buttonText;
    const onClickHandler = () => {
        (0, tab_click_1.triggerClickCardEvent)(`${clickstream_displayed_txt}_click`, btnLabel);
        if (blueCardLink) {
            window.location.href = blueCardLink;
        }
    };
    const onHoverHandler = (element, displayedTxt = '') => {
        (0, tab_click_1.triggerHoverCardElementEvent)(`${clickstream_displayed_txt}_hover`, element, displayedTxt);
    };
    return (react_1.default.createElement(constellation_1.Box, { sx: {
            backgroundColor: '$colors.blue400',
            borderRadius: '$radii.sm',
            height: '100%',
            overflow: 'hidden',
        }, onMouseEnter: () => onHoverHandler('card') },
        react_1.default.createElement(constellation_1.Image, { alt: "", height: "180px", width: "100%", src: blueCardImage || defaultLabels_1.blueCardPlaceholders.defaultImage }),
        react_1.default.createElement(constellation_1.Box, { sx: { padding: '$spacing.md' } },
            react_1.default.createElement(constellation_1.Text, { fontType: "body", as: "p", marginBottom: "md", fontColor: "white", sx: {
                    lineHeight: '$lineHeight.body',
                } }, blueCardText || defaultLabels_1.blueCardPlaceholders.informationText),
            react_1.default.createElement(constellation_1.Button, { size: "md", as: "a", buttonType: "secondary", fluid: true, onClick: onClickHandler, onMouseEnter: () => onHoverHandler('button', btnLabel) }, btnLabel))));
};
/** @component */
exports.default = PersonalizedRateCard;
